/**
 * 获取视频配置
 * @param {Object} rtcConfig - RTC 配置
 * @returns {Object} 视频配置
 */
export function getVideoConfig(rtcConfig) {
  const config = {
    encoderConfig: {
      width: 540,
      frameRate: 15,
      bitrateMin: 600,
      bitrateMax: 800,
    },
  }

  if (!rtcConfig) {
    return config
  }

  const encoderConfig = config.encoderConfig

  // 固定参数优先
  if (rtcConfig.width && rtcConfig.width > 0) {
    encoderConfig.width = rtcConfig.width
    if (rtcConfig.bitrate) {
      encoderConfig.bitrateMax = rtcConfig.bitrate
      encoderConfig.bitrateMin = Math.floor(rtcConfig.bitrate * 0.8)
    }
    if (rtcConfig.frame_rate) {
      encoderConfig.frameRate = rtcConfig.frame_rate
    }
    console.log('[AgoraRTC] Using fixed video config from server:', encoderConfig)
  } else {
    // video_options
    if (rtcConfig.video_options && rtcConfig.video_options.length > 0) {
      const normalOption = rtcConfig.video_options.find(opt => opt.video_type !== 'weak_net')
      if (normalOption) {
        encoderConfig.width = normalOption.width || encoderConfig.width
        if (normalOption.bitrate) {
          encoderConfig.bitrateMax = normalOption.bitrate
          encoderConfig.bitrateMin = Math.floor(normalOption.bitrate * 0.8)
        }
        if (normalOption.frame_rate) {
          encoderConfig.frameRate = normalOption.frame_rate
        }
        console.log('[AgoraRTC] Using video_options config:', normalOption)
      }
    }

    // hd_switch
    if (rtcConfig.hd_switch === 1 && encoderConfig.width < 720) {
      encoderConfig.width = 720
      encoderConfig.bitrateMin = 1000
      encoderConfig.bitrateMax = 1500
      console.log('[AgoraRTC] HD enabled (720p)')
    }
  }

  // enable_h265
  if (rtcConfig.enable_h265 === 1) {
    console.log('[AgoraRTC] H.265 encoding requested')
  }

  // prefer_software
  if (rtcConfig.prefer_software === true) {
    config.optimizationMode = 'detail'
    console.log('[AgoraRTC] Software encoding enabled')
  }

  // enable_capture
  if (rtcConfig.enable_capture === 1) {
    config.cameraId = undefined
    encoderConfig.width = 720
    encoderConfig.frameRate = 15
    console.log('[AgoraRTC] Custom capture config enabled (720p@15fps)')
  }

  console.log('[AgoraRTC] Final video config:', config)
  return config
}

/**
 * 获取音频配置
 * @param {Object} rtcConfig - RTC 配置
 * @returns {Object} 音频配置
 */
export function getAudioConfig(rtcConfig) {
  const audioConfig = {}

  if (rtcConfig?.reduce_audio === 1) {
    audioConfig.encoderConfig = {
      sampleRate: 48000,
      stereo: false,
      bitrate: 18,
    }
    console.log('[AgoraRTC] Audio config: reduce_audio enabled (18kbps)')
  } else {
    audioConfig.encoderConfig = 'high_quality_stereo'
  }

  return audioConfig
}
